export const DESIGNATION_DOCUMENT_DROP_DOWN_ITEMS = []